import { useState, useEffect } from 'react';
import { CUSTOMER_API_URL } from '../constants';
import axios from 'axios';
import { useEmitMessage } from './useEmitMessage';

export const useAppInitialize = () => {

  const [token, setToken] = useState('');
  const emitFailedMessage = useEmitMessage('keep');

  const injectStyleTextElementsToBody = (styleTexts: string[]) => {
    styleTexts.forEach(styleText => {
      const style = document.createElement('style');
      style.innerText = styleText;
      document.body.appendChild(style);
    });
  };

  const injectStyleUrlElementsToBody = (styleUrls: string[]) => {
    styleUrls.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.body.appendChild(link);
    });
  };

  useEffect(() => {
    const handleRecieveMessage = async (event: MessageEvent) => {

      const { code, styleTexts, styleUrls } = event.data;
      if (!code || !styleTexts || !styleUrls) return;

      try {
        const response = await axios.post(`${CUSTOMER_API_URL}?action=token`, { code });

        setToken(response.data);
        injectStyleTextElementsToBody(styleTexts);
        injectStyleUrlElementsToBody(styleUrls);

        window.removeEventListener('message', handleRecieveMessage);

      } catch(error) {

        if (axios.isAxiosError(error)) {
          if (!error.response) throw new Error(error.message);
          if (error.response.status >= 500) throw error;
          emitFailedMessage('app-not-get-token');
        }
      }
    };

    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
      
  }, [emitFailedMessage]);

  return token;
};
